var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 8.96875L8.42188 1.46875C8.98438 0.859375 9.96875 0.859375 10.5312 1.46875C11.1406 2.03125 11.1406 3.01562 10.5312 3.57812L4.10938 10L10.5312 16.4688C11.1406 17.0312 11.1406 18.0156 10.5312 18.5781C9.96875 19.1875 8.98438 19.1875 8.42188 18.5781L0.921875 11.0781C0.3125 10.5156 0.3125 9.53125 0.921875 8.96875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrow);
export default __webpack_public_path__ + "static/media/calendar-arrow.90a991810dd215b81c0aff667d687164.svg";
export { ForwardRef as ReactComponent };